import { AnalyticsDashboard } from '@/components/analytics-hr';

import { LayoutHr } from '../LayoutHr/LayoutHr';

const AnalyticsPage = () => {
	return (
		<LayoutHr title='ERP - Analytics'>
			<AnalyticsDashboard />
		</LayoutHr>
	);
};

export default AnalyticsPage;
